<template>
  <form class="row mt-2" @submit.prevent="updateStoreSettings">
      <div class="col-12 setting">
        <div class="row d-flex">
          <div class="form-group col-12 col-sm-6">
            <label class="label d-flex align-items-center">
              <span>{{ $t("storeSettings.storefront") }}</span>
              <div class="pr-1 ml-1 mr-1 d-flex" v-popover:tooltip.right="$t('storeSettings.storefrontTooltip')">
                <i class="icon icon-help tip typo-icon-14 text-light-disabled"></i>
              </div>
            </label>
            <div class="form-group password-field">
              <template v-if="shopInfo.passwordEnabled">
                <input class="input-field" :type="showPassword ? 'text' : 'password'" autocomplete="new-password" placeholder="your-storefront-password" v-model="storePassword" />
                <div class="toggle-view" @click="showPassword = !showPassword" :title="showPassword ? $t('storeSettings.hidePwd') : $t('storeSettings.showPwd')">
                  <i class="icon icon-view" v-if="!showPassword"></i>
                  <i class="icon icon-view-off" v-else></i>
                </div>
              </template>
              <input class="input-field disabled" type="password" autocomplete="new-password" disabled v-else />
            </div>
            <p class="typo-paragraph14 typo-italic text-danger mt-1" v-if="wrongPassword" v-html="$t('storeSettings.wrongPass', { domain: shopInfo.shopifyDomain })" />
            <p class="typo-paragraph14 text-light-low typo-italic mt-1 pwd" v-html="$t('storeSettings.storePasswordFoot', { domain: shopInfo.shopifyDomain })"></p>
          </div>
        </div>
        <div class="row setting-block d-flex">
          <div class="col-12">
            <div class="bt1stdmh"></div>
          </div>
        </div>
      </div>
      <div class="col-12 setting other-settings">
        <div class="row">
          <div class="col-12">
            <p class="typo-button14 typo-medium text-light-high">{{ $t("storeSettings.other.title") }}</p>
          </div>
        </div>
        <div class="row">
          <!-- productSchema -->
          <div class="col-12 col-md-6 mt-2">
            <Switcher v-model="settings.productSchema" type="toggle">
              <template #title>{{ $t("storeSettings.other.productSchema.title") }}</template>
              <template #subtitle>{{ $t("storeSettings.other.productSchema.subtitle") }}</template>
            </Switcher>
          </div>
          <!-- themeScript -->
          <div class="col-12 col-md-6 mt-2">
            <Switcher v-model="settings.themeScript" type="toggle">
              <template #title>{{ $t("storeSettings.other.themeScript.title") }}</template>
              <template #subtitle>{{ $t("storeSettings.other.themeScript.subtitle") }}</template>
            </Switcher>
          </div>
          <!-- lazyload -->
          <!-- <div class="col-12 col-md-6 mt-2">
            <Switcher v-model="settings.lazyload" type="toggle" disabled>
              <template #title>{{ $t("storeSettings.other.lazyload.title") }}</template>
              <template #subtitle>{{ $t("storeSettings.other.lazyload.subtitle") }}</template>
            </Switcher>
          </div> -->
          <!-- scriptPreload -->
          <div class="col-12 col-md-6 mt-2">
            <Switcher v-model="settings.preloadScript" type="toggle">
              <template #title>{{ $t("storeSettings.other.preloadScript.title") }}</template>
              <template #subtitle>{{ $t("storeSettings.other.preloadScript.subtitle") }}</template>
            </Switcher>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row mt-6 pb-6 d-flex">
          <div class="col-12 justify-content-end btn-group">
            <button type="button" class="btn btn-outline mr-1" @click="cancel">{{ $t("generals.cancel") }}</button>
            <ProcessButton class="ml-0" :status.sync="status" type="submit" default="btn-secondary">
              <template #loading>{{ $t("generals.saving") }}</template>
              <template #success>{{ $t("generals.save") }} {{ $t("generals.success") }}</template>
              <template #error>{{ $t("generals.save") }} {{ $t("generals.fail") }}</template>
              <template #default>{{ $t("generals.save") }} {{ $tc("generals.setting", 2) }}</template>
            </ProcessButton>
          </div>
        </div>
      </div>
    </form>
</template>

<script>
import Switcher from "@/core/shared/essenstials/Switcher.vue";
import {ProcessButton} from "@/core/shared";
import errorHandle from "@/mixins/errorHandle.js";
import {mapActions, mapState} from "vuex";
import {actions} from "@/store/account/types";
export default {
  components: {
    Switcher,
    ProcessButton,
  },
  filters: {
    upperCaseFirstLetter(str) {
      str = str.charAt(0).toUpperCase() + str.slice(1);
      return str;
    }
  },
  mixins: [errorHandle()],
  data: () => ({
    storePassword: "",
    showPassword: false,
    wrongPassword: false,
    settings: {
      productSchema: false,
      lazyload: false,
      themeScript: false
    },
    highlight: {},
  }),
  computed: {
    ...mapState("account", {
      status: state => state.status,
      shopInfo: state => state.shopInfo
    }),
    ...mapState("agency", {
      agencyLogged: state => state.logged
    }),
    shopPlan() {
      return this.shopInfo.plan.charAt(0).toUpperCase() + this.shopInfo.plan.slice(1);
    },
  },
  watch: {
    shopInfo(newV) {
      this.assignInfo(newV);
    }
  },
  created() {
    this.assignInfo(this.shopInfo);
    this.$router.push({name: "AccountSettings"});
  },
  methods: {
    ...mapActions("account", {
      updateStoreInfo: actions.ACCOUNT_UPDATE_STORE_INFO
    }),
    goToUpgrade() {
      this.$router.push({name: "Pricing"});
    },
    cancel() {
      if (this.prevRoute.name != null) this.$router.go(-1);
      else this.$router.push({name: "Dashboard"});
    },
    assignInfo(shopInfo) {
      this.storePassword = shopInfo.password || "";
      if (shopInfo?.storeInfo) {
        this.settings.productSchema = shopInfo.storeInfo.productSchema;
        this.settings.themeScript = shopInfo.storeInfo.themeScript;
        this.settings.preloadScript = shopInfo.storeInfo.preloadScript;
      }
    },
    updateStoreSettings() {
      this.updateStoreInfo({
        data: {
          password: this.storePassword,
          productSchema: this.settings.productSchema,
          themeScript: this.settings.themeScript,
          preloadScript: this.settings.preloadScript,
          type: "store"
        },
        onSuccess: () => {
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
        },
        onError: err => {
          this.cancelChangeLanguage();
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
        }
      });
    },
  }
}
</script>
<style lang="scss" scoped>
.bt1stdmh {
  border-top: 1px solid $textDarkModeHigh;
}
.input-field {
  background-color: $light2;
  width: 100%;
}
.setting {
  margin-top: 24px;
  &-block {
    .block {
      background: $neutral5;
      height: 100%;
      .icon {
        img {
          width: 40px;
          height: auto;
        }
      }
    }
    .form-group {
      margin-top: 0px !important;
      padding-top: 24px;
      .form-group {
        padding-top: 0px;
      }
    }
    &:not(:first-child) {
      padding-top: 24px;
    }
  }
}
.center {
  align-items: center;
}
button {
  height: 40px;
  min-width: 160px;
}
.pwd {
  a {
    &:hover {
      display: none;
    }
  }
}
@keyframes highlight {
  0% {
    box-shadow: 0 0 5px 0 $accent-red;
  }
  25% {
    box-shadow: 0 0 15px 2px $accent-red;
  }
  50% {
    box-shadow: 0 0 5px 0 $accent-red;
  }
  75% {
    box-shadow: 0 0 15px 2px $accent-red;
  }
  100% {
    box-shadow: 0 0 5px 0 $accent-red;
  }
}
.highlight {
  animation: highlight 1.5s alternate ease-out 2;
}
</style>
